var _sodipodiNamedview, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberOfSurveysIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "500 250 3000 250",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    bordercolor: "#000000",
    borderopacity: 0.25,
    pagecolor: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 1440)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1256.9 148.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-593.71v781.6h321.96l271.76-238.96z",
    fill: "none",
    stroke: "#095170",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 58.094
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(985.18 691.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 238.961 L 271.755,0 H 8",
    fill: "none",
    stroke: "#095170",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 58.094
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780.25 629.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h100.49",
    fill: "none",
    stroke: "#095170",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 42
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780.25 548.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h359.65",
    fill: "none",
    stroke: "#095170",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 42
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780.25 467.45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h359.65",
    fill: "none",
    stroke: "#095170",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 42
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780.25 386.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h359.65",
    fill: "none",
    stroke: "#095170",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 42
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780.25 305.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h359.65",
    fill: "none",
    stroke: "#095170",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 42
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberOfSurveysIcon);
export default __webpack_public_path__ + "static/media/NumberOfSurveysIcon.b278b90b642d5e89a4f5d80934f7e191.svg";
export { ForwardRef as ReactComponent };